import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import * as actions from '../../features/deployment-setting/redux/actions';
import GithubExportList from './github-export/GithubExportList.js';
import ExportNav from './ExportNav';
import CommonPageComponent from '../../common/ui/CommonPageComponent.js';
import { drapcodeIcon } from '../../common/custom/icon-library';
import { permissionTypes } from 'drapcode-constant';
import GithubUserData from './github-export/GithubUserData';

export class GithubExport extends Component {
  static propTypes = {
    deploymentSetting: PropTypes.object.isRequired,
    actions: PropTypes.object.isRequired,
  };

  componentDidMount() {
    const { match, actions } = this.props;
    const { projectId, version } = match.params;
    actions.loadPermissionFlags({ projectId });
    actions.loadProjectDepSetting({ projectId, version });
    actions.listGithubExportList({ projectId, version });
  }

  render() {
    const { match, actions, deploymentSetting } = this.props;
    const { projectId, version } = match.params;
    const { permissionFlags, githubExportList, listGithubExportRequestPending } = deploymentSetting;

    let permissionsArray = [];
    if (permissionFlags && permissionFlags.length > 0) {
      permissionsArray = permissionFlags || [];
    }

    return (
      <CommonPageComponent>
        <ExportNav activeTab={'Github'} version={version} projectId={projectId} />
        <div className="col-12 drapcode">
          <div className="card">
            <div className="card-header card-header-icon" data-background-color="drapcode-violet">
              <i className={`wb ${drapcodeIcon('github')}`}></i>
            </div>
            <div className="card-content">
              <div className="card-title-header">
                <h4 className="card-title">Github Setting (Beta)</h4>
              </div>
              <GithubUserData
                projectId={projectId}
                actions={actions}
                deploymentSetting={deploymentSetting}
                version={version}
              />
            </div>
          </div>

          <div className="card">
            <div className="card-header card-header-icon" data-background-color="drapcode-violet">
              <i className={`wb ${drapcodeIcon('list')}`}></i>
            </div>
            <div className="card-content">
              <div className="card-title-header">
                <h4 className="card-title">Github Setting List</h4>
                <div className="card-cta"></div>
              </div>
              <GithubExportList
                projectId={projectId}
                githubExportList={githubExportList}
                listGithubExportRequestPending={listGithubExportRequestPending}
                deleteGithubExportRequest={actions.deleteGithubExportRequest}
                deleteFlag={permissionsArray.includes(permissionTypes.CODE_EXPORT)}
                version={version}
              />
            </div>
          </div>
        </div>
      </CommonPageComponent>
    );
  }
}

function mapStateToProps(state) {
  return {
    deploymentSetting: state.deploymentSetting,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators({ ...actions }, dispatch),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(GithubExport);
